export default __webpack_public_path__ + "static/media/MP2.31a9af1f.jpg";